import styled from 'styled-components';

export const StyledTableProgressLabel = styled.label`
    width: 100%;
    display: flex;
    justify-content: space-between;
`

export const StyledBar = styled.progress`
    width: 100%;  
`;